export default __webpack_public_path__ + "static/media/20-1.a3cec364.mp3";